import { Typography, CardContent } from "@mui/material";

export const Header = ({ title }) => {
  return (
    <CardContent sx={{ pb: 0 }}>
      <Typography variant="h5">{title}</Typography>
    </CardContent>
  );
};
